/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ArchivedProjectsAdminType from '@jira/spa-apps__admin-pages-archived-projects/src/AdminPagesArchivedProjectsArchivedProjectsAdminType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyArchivedProjectsAdmin: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ArchivedProjectsAdminType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-archived-projects", jiraSpaEntry: "async-archived-projects" */ '@jira/spa-apps__admin-pages-archived-projects/src/AdminPagesArchivedProjectsArchivedProjectsAdminType.tsx'
		),
	),
);

const AsyncArchivedProjectsAdmin = (): React.JSX.Element => (
	<LazyPage Page={LazyArchivedProjectsAdmin} pageId="archived-projects" shouldShowSpinner />
);

export default AsyncArchivedProjectsAdmin;
